const KlydoFrame: React.FC<{ photoUrl: string }> = ({ photoUrl }) => {
  return (
    <img
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
      loading="eager"
      height={96}
      width={96}
      src={photoUrl}
      alt="klydo"
    />
  );
};

export default KlydoFrame;
